import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { Observable, switchMap } from 'rxjs';

import { BaseColumnComponent } from '../../../../record/services/base-column-component';
import { DownloadRow, StatusCellData } from '../../../entities/download-row.entity';

@Component({
    standalone: false,
    selector: 'digihaven-download-status-cell',
    templateUrl: './download-status-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadStatusCellComponent extends BaseColumnComponent<DownloadRow> {
    readonly status$: Observable<StatusCellData>;

    constructor(cd: ChangeDetectorRef) {
        super(cd);

        this.status$ = this.data$.pipe(switchMap(row => row.status$));
    }

    asPercentage(progress: number): number {
        return Math.round(progress * 100);
    }
}
